

.drawer{
  display: flex;
  flex-direction: column;
  border-top-left-radius: 2rem;
  border-top-right-radius: 2rem;
  height: 90vh;
  background: var(--drawer-background);
  color: var(--drawer-color);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  transition: transform 200ms, opacity 50ms;
  padding: 2rem;
}

.drawer-open{
  visibility: visible;
  transform: translateY(0);
  opacity: 1;
  z-index: 999;
}

.drawer-close{
  visibility: hidden;
  z-index: -1;
  transform: translateY(30%);
  opacity: 0;
  transition: none;
}

.close{
  display: flex;
  justify-content: flex-end;
  font-size: 3rem;
}

.content{
  overflow: auto;
  flex: 1;
}

@media (min-width: 420px) {
  .drawer{
    width: 34rem;
    height: fit-content;
    max-height: 98vh;
    left: 50%;
    top: 50%;
    border-radius: 2rem;
  }

  .drawer-open{
    transform: translateX(-50%) translateY(-50%);
  }

  .drawer-close{
    transform: translateX(-50%) translateY(-30%);
  }
}
